export default "__VITE_ASSET__DPGyatvW__"